import {
  ALERT_LEVELS,
  ALERT_SOURCE_APP_BY_SOURCE_ID,
  ALERT_SOURCE_IDS
} from '../../constants/cmConstants';

export const formatAlertActionByStatus = ({ isAssigned, statusCode }) =>
  ({
    UNASSIGNED: 'Unassign',
    ASSIGNED: isAssigned ? 'Re-Assign' : 'Assign',
    RE_OPENED: 'Re-Open'
  }[statusCode]);

export const formatAlertLevel = (level) =>
  ({
    [ALERT_LEVELS[0]]: 'Low',
    [ALERT_LEVELS[1]]: 'Good',
    [ALERT_LEVELS[2]]: 'High'
  }[level]);

const ALERT_SOURCE_ID_LABELS = {
  [ALERT_SOURCE_IDS.TMSAM]: 'TMSAM',
  [ALERT_SOURCE_IDS.TMSAM_ANOMALY]: 'TMSAM Anomaly',
  [ALERT_SOURCE_IDS.NSIAD]: 'NSIAD',
  [ALERT_SOURCE_IDS.NSSAM]: 'NSSAM',
  [ALERT_SOURCE_IDS.TSSAM]: 'TSSAM',
  [ALERT_SOURCE_IDS.CRS_FIRST_TIME_RISK]: 'Customer Risk Scoring',
  [ALERT_SOURCE_IDS.CRS_PERIODIC_REVIEW]: 'Customer Risk Scoring',
  [ALERT_SOURCE_IDS.CRS_RISK_CHANGE]: 'Customer Risk Scoring',
  [ALERT_SOURCE_IDS.CRS_OTHERS]: 'Customer Risk Scoring',
  [ALERT_SOURCE_IDS.TMIAD]: 'TMIAD',
  [ALERT_SOURCE_IDS.NSIAD_RUN_INSTANCE]: 'NSIAD Run Instance',
  [ALERT_SOURCE_IDS.TMIAD_RUN_INSTANCE]: 'TMIAD Run Instance',
  [ALERT_SOURCE_IDS.TSIAD]: 'TSIAD',
  [ALERT_SOURCE_IDS.CRS_PRIORITISE_ALERT]: 'Customer Prioritise Alert',
  [ALERT_SOURCE_IDS.FRAUDIAD]: 'Fraud',
  [ALERT_SOURCE_IDS.RTFRAUDIAD]: 'Fraud',
  [ALERT_SOURCE_IDS.INACTIVE_MONTHLY]: 'Inactive Monthly'
};

export const formatAlertSourceId = (sourceId) =>
  ALERT_SOURCE_ID_LABELS[sourceId];

export const formatAlertSource = (sourceId) =>
  ALERT_SOURCE_APP_BY_SOURCE_ID[sourceId];

export const filterAlertStatusFromWorkflowStatus = (statuses) =>
  statuses?.filter(
    (status) =>
      status.code !== 'ON_HOLD' &&
      status.code !== 'ISSUE_NOT_STR' &&
      status.code !== 'ISSUE_REPORT_STR'
  );
